import * as React from 'react';

type FireProps = {
    width?: number;
    height?: number;
    className?: string;
};

const FireDisabled: React.FC<FireProps> = ({width = 12, height = 12, className}) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 29 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect y="0.00195312" width="28.5714" height="24.0741" rx="10" fill="#A6A6A6" />
            <path
                d="M19.5 6.04511C19.6778 6.08416 19.8367 6.1689 19.9547 6.28756C20.0726 6.40622 20.1438 6.5529 20.1583 6.70721L20.9074 14.6679C20.9073 17.7484 17.9327 20.2547 14.2768 20.2548C13.4067 20.2554 12.5449 20.111 11.7412 19.8301C10.9374 19.5492 10.2075 19.1372 9.59327 18.6179C8.39053 17.6044 7.64541 16.2033 7.64611 14.6573L7.7671 7.28336C7.76957 7.137 7.82316 6.99451 7.92117 6.87365C8.01917 6.7528 8.15726 6.65895 8.31818 6.60382C8.4791 6.5487 8.65572 6.53473 8.826 6.56367C8.99628 6.59262 9.15266 6.66318 9.27562 6.76657L11.3392 8.50529L13.4268 2.34807C13.4802 2.19295 13.5919 2.05662 13.7451 1.95959C13.8984 1.86255 14.0848 1.81005 14.2765 1.80999C14.4682 1.80992 14.6547 1.86229 14.808 1.95922C14.9613 2.05615 15.0731 2.1924 15.1266 2.34748L17.1018 8.17325L18.5416 6.35329C18.6437 6.2245 18.7908 6.12565 18.9625 6.07044C19.1342 6.01522 19.3221 6.00637 19.5 6.04511ZM11.4634 12.2973C10.7173 12.926 10.2981 13.7787 10.298 14.6678C10.298 15.5568 10.7171 16.4094 11.4632 17.0381C12.2092 17.6667 13.2212 18.0199 14.2763 18.0198C15.3315 18.0198 16.3434 17.6666 17.0895 17.0379C18.0711 16.2109 18.4287 15.0594 18.1706 13.9938C18.1243 14.0433 18.0818 14.0949 18.0274 14.1408C17.8423 14.2967 17.6185 14.4161 17.372 14.4903C17.1256 14.5645 16.8626 14.5917 16.6022 14.5699C16.3417 14.5481 16.0903 14.4778 15.866 14.3642C15.6417 14.2506 15.4501 14.0964 15.3051 13.9128C15.1601 13.7293 15.0653 13.5209 15.0275 13.3027C14.9897 13.0844 15.0098 12.8619 15.0865 12.651C15.1632 12.4402 15.2944 12.2463 15.4708 12.0833C15.6472 11.9204 15.8643 11.7925 16.1064 11.7088C14.6073 11.0504 12.7225 11.2364 11.4634 12.2973Z"
                fill="#E5E5EA"
            />
        </svg>
    );
};

export default FireDisabled;
